/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGAModelBuilderFieldQueryVariables = {|
  slateId: string
|};
export type PGAModelBuilderFieldQueryResponse = {|
  +playersForSlate: ?$ReadOnlyArray<?{|
    +player: {|
      +name: string,
      +shortenedName: ?string,
    |},
    +salary: number,
  |}>
|};
export type PGAModelBuilderFieldQuery = {|
  variables: PGAModelBuilderFieldQueryVariables,
  response: PGAModelBuilderFieldQueryResponse,
|};
*/


/*
query PGAModelBuilderFieldQuery(
  $slateId: ID!
) {
  playersForSlate(slateId: $slateId) {
    player {
      name
      shortenedName
      id
    }
    salary
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slateId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slateId",
    "variableName": "slateId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortenedName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salary",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderFieldQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SlatePlayerType",
        "kind": "LinkedField",
        "name": "playersForSlate",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PlayerType",
            "kind": "LinkedField",
            "name": "player",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGAModelBuilderFieldQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SlatePlayerType",
        "kind": "LinkedField",
        "name": "playersForSlate",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PlayerType",
            "kind": "LinkedField",
            "name": "player",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8182ea24a2e1e576b6f48899b4f9679e",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderFieldQuery",
    "operationKind": "query",
    "text": "query PGAModelBuilderFieldQuery(\n  $slateId: ID!\n) {\n  playersForSlate(slateId: $slateId) {\n    player {\n      name\n      shortenedName\n      id\n    }\n    salary\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a4f50b9eb8afc4311f46835c939425b4';

module.exports = node;
